// extracted by mini-css-extract-plugin
module.exports = {"workspaceSelection":"WorkspaceSelection--workspaceSelection--OvHUq","breadcrumb":"WorkspaceSelection--breadcrumb--33FVf","link":"WorkspaceSelection--link--u0KxA"};